(ns ui.alert
  (:require [ui.typography :as typo]
            ["lucide-react" :refer [AlertTriangle Info]]
            [ui.utils :refer [clsx separate-props]]))

(defn alert-title [& args]
  (let [[props children] (separate-props args)]
    (into [typo/h4 props] children)))

(defn alert [& args]
  (let [[props children] (separate-props args)
        {:keys [title icon class variant size]} props
        icon (or icon
                 (case variant
                   :info Info
                   AlertTriangle))]
    [:div {:class (clsx "rounded-md flex"
                        (case variant
                          :success "bg-kleene-primary-05 text-kleene-primary-v2"
                          :error   "bg-kleene-error-05 text-kleene-error-01"
                          :info    "bg-kleene-background-secondary text-kleene-text-secondary"
                          "bg-kleene-warning-05 text-kleene-warning-01")
                        (case size
                          :xsmall "px-1 pt-1 pb-0.5 text-xs gap-1 [&_h4]:text-xs"
                          "px-4 pt-4 pb-3 gap-5")
                        class)}
     (when icon [:div [:> icon {:size  (case size
                                         :xsmall 16
                                         20)}]])
     [:div
      (when title [alert-title title])
      (when (seq children)
        (into [:<>] children))]]))
